import Facebook from "@/pixels/providers/facebook";
import Vue from "vue";
import { ERROR_SOLICITUD, RECHAZADO } from "@/config/constants/step-constants";

describe("Facebook config", () => {
  beforeEach(() => {
    jest.spyOn(Facebook, "enable");
    jest.spyOn(Facebook, "wait");
    jest.spyOn(Facebook, "landing");
    jest.spyOn(Facebook, "init");
    jest.spyOn(Facebook, "oferta");
    jest.spyOn(Facebook, "sucursal");
    jest.spyOn(Facebook, "paso1");
    jest.spyOn(Facebook, "paso2");
    jest.spyOn(Facebook, "paso3");
    jest.spyOn(Facebook, "paso4");
    jest.spyOn(Facebook, "thankYou");
    jest.spyOn(Facebook, "cliente");
    jest.spyOn(Facebook, "noCliente");
    jest.spyOn(Facebook, "ofertaEmprendedores_consulta");
    jest.spyOn(Facebook, "ofertaEmprendedores_oferta");
    jest.spyOn(Facebook, "consulta_ofertaCajaAhorro");
    jest.spyOn(Facebook, "ofertaCuenta_ofertaCajaAhorro");
    jest.spyOn(Facebook, "mensaje_ofertaCajaAhorro");
    jest.spyOn(Facebook, "ofertaCuenta");
    jest.spyOn(Facebook, "graciasCajaAhorro");

    document.createElement = jest.fn(() => ({
      addEventListener: jest.fn()
    }));
    document.getElementsByTagName = jest.fn(() => [
      {
        appendChild: jest.fn(),
        parentNode: {
          insertBefore: jest.fn()
        }
      }
    ]);
    Vue.$log = {
      info: jest.fn()
    };
  });
  it("configuracion exportada por defecto", () => {
    expect(Facebook).toBeDefined();
    expect(Facebook).not.toBeNull();
  });

  it("configuracion por defecto", () => {
    const context = {
      state: {
        paquetesBeneficios: {
          caracteristicas: {
            tipoPaquete: "04"
          }
        }
      }
    };

    Facebook.enable();
    Facebook.wait();
    Facebook.init();
    Facebook.landing();
    Facebook.oferta(context);
    Facebook.sucursal();
    Facebook.paso1(context);
    Facebook.paso2(context);
    Facebook.paso3(context);
    Facebook.paso4(context);
    Facebook.thankYou(context);
    Facebook.cliente();
    Facebook.noCliente();
    Facebook.ofertaEmprendedores_consulta();
    Facebook.ofertaEmprendedores_oferta();
    Facebook.consulta_ofertaCajaAhorro();
    Facebook.ofertaCuenta_ofertaCajaAhorro();
    Facebook.mensaje_ofertaCajaAhorro();
    Facebook.ofertaCuenta();
    Facebook.graciasCajaAhorro();

    const enableMock = jest.spyOn(Facebook, "enable");
    const waitMock = jest.spyOn(Facebook, "wait");
    const initMock = jest.spyOn(Facebook, "init");
    const landingMock = jest.spyOn(Facebook, "landing");
    const ofertaMock = jest.spyOn(Facebook, "oferta");
    const sucursalMock = jest.spyOn(Facebook, "sucursal");
    const paso1Mock = jest.spyOn(Facebook, "paso1");
    const paso2Mock = jest.spyOn(Facebook, "paso2");
    const paso3Mock = jest.spyOn(Facebook, "paso3");
    const paso4Mock = jest.spyOn(Facebook, "paso4");
    const thankYouMock = jest.spyOn(Facebook, "thankYou");
    const clienteMock = jest.spyOn(Facebook, "cliente");
    const noClienteMock = jest.spyOn(Facebook, "noCliente");
    const ofertaEmprendedoresConsultaMock = jest.spyOn(
      Facebook,
      "ofertaEmprendedores_consulta"
    );
    const ofertaEmprendedoresOfertaMock = jest.spyOn(
      Facebook,
      "ofertaEmprendedores_oferta"
    );
    const consultaOfertaCajaAhorroMock = jest.spyOn(
      Facebook,
      "consulta_ofertaCajaAhorro"
    );
    const ofertaCuentaOfertaCajaAhorroMock = jest.spyOn(
      Facebook,
      "ofertaCuenta_ofertaCajaAhorro"
    );
    const mensajeOfertaCajaAhorroMock = jest.spyOn(
      Facebook,
      "mensaje_ofertaCajaAhorro"
    );
    const ofertaCuentaMock = jest.spyOn(Facebook, "ofertaCuenta");
    const graciasCajaAhorroMock = jest.spyOn(Facebook, "graciasCajaAhorro");

    expect(enableMock).toHaveBeenCalledTimes(1);
    expect(waitMock).toHaveBeenCalledTimes(1);
    expect(initMock).toHaveBeenCalledTimes(1);
    expect(landingMock).toHaveBeenCalledTimes(1);
    expect(ofertaMock).toHaveBeenCalledTimes(1);
    expect(sucursalMock).toHaveBeenCalledTimes(1);
    expect(paso1Mock).toHaveBeenCalledTimes(1);
    expect(paso2Mock).toHaveBeenCalledTimes(1);
    expect(paso3Mock).toHaveBeenCalledTimes(1);
    expect(paso4Mock).toHaveBeenCalledTimes(1);
    expect(thankYouMock).toHaveBeenCalledTimes(1);
    expect(clienteMock).toHaveBeenCalledTimes(1);
    expect(noClienteMock).toHaveBeenCalledTimes(1);
    expect(ofertaEmprendedoresConsultaMock).toHaveBeenCalledTimes(1);
    expect(ofertaEmprendedoresOfertaMock).toHaveBeenCalledTimes(1);
    expect(consultaOfertaCajaAhorroMock).toHaveBeenCalledTimes(1);
    expect(ofertaCuentaOfertaCajaAhorroMock).toHaveBeenCalledTimes(1);
    expect(mensajeOfertaCajaAhorroMock).toHaveBeenCalledTimes(1);
    expect(ofertaCuentaMock).toHaveBeenCalledTimes(1);
    expect(graciasCajaAhorroMock).toHaveBeenCalledTimes(1);
  });

  it("los metodos de ofertaEmprendedores si se genera una key", () => {
    const context = {
      state: {
        key: "key"
      }
    };
    Facebook.ofertaEmprendedores_oferta(context);

    const ofertaEmprendedoresOfertaMock = jest.spyOn(
      Facebook,
      "ofertaEmprendedores_oferta"
    );

    expect(ofertaEmprendedoresOfertaMock).toHaveBeenCalledTimes(2);
  });

  it("los metodos de mensaje para ERROR_SOLICITUD", () => {
    const args = {
      mutation: {
        payload: {
          params: {
            mje: ERROR_SOLICITUD
          }
        }
      }
    };

    Facebook.mensaje_ofertaCajaAhorro(args);
    const mensajeOfertaCajaAhorroMock = jest.spyOn(
      Facebook,
      "mensaje_ofertaCajaAhorro"
    );
    expect(mensajeOfertaCajaAhorroMock).toHaveBeenCalledTimes(2);
  });

  it("los metodos de mensaje para RECHAZADO", () => {
    const args = {
      mutation: {
        payload: {
          params: {
            mje: RECHAZADO
          }
        }
      }
    };

    Facebook.mensaje_ofertaCajaAhorro(args);
    const mensajeOfertaCajaAhorroMock = jest.spyOn(
      Facebook,
      "mensaje_ofertaCajaAhorro"
    );
    expect(mensajeOfertaCajaAhorroMock).toHaveBeenCalledTimes(3);
  });

  it("efecto", () => {
    window.fbq = jest.fn();

    Facebook.enable();
    const enableMock = jest.spyOn(Facebook, "enable");
    expect(enableMock).toHaveBeenCalledTimes(2);
  });
});
